var _path, _mask, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.14554H21M19.6154 3H4.38462C4.01739 3 3.66521 3.14588 3.40554 3.40554C3.14588 3.66521 3 4.01739 3 4.38462V19.6154C3 19.9826 3.14588 20.3348 3.40554 20.5945C3.66521 20.8541 4.01739 21 4.38462 21H19.6154C19.9826 21 20.3348 20.8541 20.5945 20.5945C20.8541 20.3348 21 19.9826 21 19.6154V4.38462C21 4.01739 20.8541 3.66521 20.5945 3.40554C20.3348 3.14588 19.9826 3 19.6154 3Z",
    stroke: "#101828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3013_8751",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 8,
    height: 7,
    rx: 1,
    stroke: "#101828",
    strokeWidth: 2.4,
    mask: "url(#path-2-inside-1_3013_8751)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13L19 13",
    stroke: "#101828",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L19 15",
    stroke: "#101828",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWebsite);
export default __webpack_public_path__ + "static/media/ico-website.6807c05fd16b72305ad15a5de5359f20.svg";
export { ForwardRef as ReactComponent };